module.exports = __webpack_public_path__ + "static/media/au-vic.100dd8a2.svg";